import { SVGProps } from 'react'

export const DigitalResearchNotebookIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    xmlSpace="preserve"
    enableBackground="new 0 0 250 250"
    viewBox="0 0 250 250"
    {...props}
  >
    <image
      xlinkHref="BBE6028A.jpg"
      width={300}
      height={91}
      style={{
        overflow: 'visible',
      }}
      transform="translate(751 -250.5)"
    />
    <path d="M125.5 3.4c29.4 17.9 58.9 35.7 88.3 53.6 3.9 2.4 4 4.7.2 7-20 12.2-40.2 24.3-60.3 36.4-3.3 2-6.6 1.9-9.9-.1-4.4-2.7-8.9-5.2-13.2-8.1-4-2.7-7.6-2.5-11.5.1-4.3 2.9-8.8 5.3-13.2 8-3.5 2.2-6.8 2.1-10.3 0-19.8-12-39.6-24-59.3-36-4.4-2.7-4.3-4.9.2-7.6 29.3-17.8 58.6-35.5 87.9-53.3h1.1zm103 77c-1.8-.1-3.9-.9-5.2-.1-20.1 12-40.1 24.3-60.2 36.5-3.3 2-4.9 4.8-4.9 8.7.1 5.8-.1 11.7 0 17.5.1 4.2-1.5 7.3-5.3 9.4-4.2 2.3-8.2 5.2-12.4 7.4-4.9 2.5-6.7 6.3-6.6 11.7.2 23.2 0 46.3.1 69.5 0 1.8.9 3.7 1.3 5.5 1.8-.6 3.8-1 5.4-1.9 27.5-16.6 54.9-33.3 82.3-50.1 2-1.3 3.6-3.3 5.4-5 .1-36.4.1-72.7.1-109.1zm-207 109c1.8 1.7 3.4 3.6 5.4 4.9 5 3.3 10.2 6.3 15.3 9.4 22.6 13.7 45.2 27.5 67.8 41.2 4.5 2.7 6 2.1 6-2.6.1-24.1 0-48.3 0-72.4 0-4.4-1.9-7.5-5.8-9.7-4.5-2.5-8.8-5.5-13.2-8-3.7-2.1-5.4-5.2-5.3-9.4.1-6.2.4-12.4-.2-18.5-.2-2.4-1.8-5.6-3.8-6.8-20.2-12.6-40.5-24.9-60.9-37.1-1.3-.8-3.5 0-5.3 0v109z" />
  </svg>
)
